export enum ErrorContext {
    ERROR = 'error',
    DISABLED_MAINTENANCE = 'disabled-maintenance',
    DISABLED_DISRUPTION = 'disabled-disruption',
    BROWSERTOKEN = 'browserToken',
    NO_COOKIES = 'no-cookies',
    UNDEFINED = 'undefined'
}
